import { motion } from "framer-motion";
import { Chip } from "@nextui-org/react";
import { useTranslation } from "react-i18next";
import { useRef, useState } from "react";
import { MdOutlinePlayCircle } from "react-icons/md";

export default function Hero() {
  const { t } = useTranslation();
  const [isPlaying, setIsPlaying] = useState(false);
  const videoRef = useRef(null);

  const handlePlay = () => {
    if (videoRef.current) {
      videoRef.current.play();
      setIsPlaying(true);
    }
  };

  return (
    <>
      <section className="mt-10  lg:mt-20 flex flex-col lg:flex-row justify-between items-center gap-10 -mb-[10%] md:-mb-[0%] relative z-10 w-[85%] m-auto ">
        <motion.div className="order-2 lg:order-1 flex flex-col items-start justify-center gap-4 w-full lg:w-[50%]">
          <div className="flex flex-col ">
            <Chip className="self-center  h-8 lg:self-start bg-gray-800 text-white p-2 text-base">
              <span>{t("herochip")}</span>
            </Chip>

            <h1 className=" text-black font-bold text-xl lg:text-2xl xl:text-3xl 2xl:text-4xl text-center mt-5 leading-loose lg:mb-5 lg:text-left lg:rtl:text-right">
              {t("heroh1")}
            </h1>

            <p className=" xl:text-xl  mb-4">{t("herocontent")}</p>
          </div>

          {/* Button Area */}
        </motion.div>

        <div className="order-1 lg:order-2 w-full sm:w-[80%] md:w-[70%] lg:w-[40%] relative  ">
          <video
            controls
            poster="Assets/Images/Dazhou copy.png"
            ref={videoRef}
            onPlay={() => setIsPlaying(true)}
            className="w-full"
          >
            <source
              src="https://api.fidarsp.com/media/videos/tiser.mp4"
              type="video/mp4"
            />
          </video>
          {!isPlaying && (
            <button
              onClick={handlePlay}
              className="absolute top-0 left-0 w-full h-full flex items-center justify-center bg-black bg-opacity-40 text-white"
            >
              <MdOutlinePlayCircle className="text-[80px] lg:text-[120px] " />
            </button>
          )}
        </div>
      </section>
    </>
  );
}
